import React from "react"
import { useSearchParams } from "react-router-dom"
import ArrowIcon from "./assets/arrow.svg"
import "./zidpay.css"

const ZidPayDemo = () => {
  const [searchParams] = useSearchParams()

  // @ts-ignore
  const { renderTapConnect, Language } = window.TapPayments
  let unmountConnect = null
  const startConnectAuth = () => {
    const { unmount } = renderTapConnect(
      {
        publicKey: searchParams.get("pk") || "pk_test_lat64TEDSvHrUOYAxVRe28PQ",
        language: Language.EN,
        domain: "https://example.com",
        country: "SA",
        scope: "merchant",
        lead: searchParams.get("leadId") ?? undefined,
        mature: searchParams.get("mature") === "false" ? false : true,
        board: true,
        boardMaturity: searchParams.get("boardMaturity") === "false" ? false : true,
        open: true,
        postURL: "https://api.example.com/post",
        onReady: () => console.log("onReady"),
        onCreated: (data: any) => console.log("onCreated", data),
        onError: (err: any) => console.log("onError", err),
        onClose: () => console.log("onClose"),
        onBoardCompleted: () => console.log("onBoardCompleted")
      },
      "connect"
    )
    // save the unmount function to be able to unmount the component
    unmountConnect = unmount
  }

  return (
    <main className='zidpay_main'>
      <form className='zidpay_form'>
        <fieldset className='zidpay_container'>
          <button type='button' className='zidpay_container__button' onClick={() => startConnectAuth()}>
            <span>Connect</span>
            <img src={ArrowIcon} alt='connect' />
          </button>
        </fieldset>
      </form>
    </main>
  )
}

export default ZidPayDemo
